export var ClassicGameId;
(function (ClassicGameId) {
    ClassicGameId[ClassicGameId["LUCKY7"] = 1] = "LUCKY7";
    ClassicGameId[ClassicGameId["LUCKY6"] = 9] = "LUCKY6";
    ClassicGameId[ClassicGameId["LUCKY5"] = 3] = "LUCKY5";
    ClassicGameId[ClassicGameId["DICE_DUEL"] = 10] = "DICE_DUEL";
    ClassicGameId[ClassicGameId["WHEEL"] = 7] = "WHEEL";
    ClassicGameId[ClassicGameId["POKER"] = 5] = "POKER";
    ClassicGameId[ClassicGameId["SIX_PLUS_POKER"] = 12] = "SIX_PLUS_POKER";
    ClassicGameId[ClassicGameId["BACCARAT"] = 6] = "BACCARAT";
    ClassicGameId[ClassicGameId["WAR"] = 8] = "WAR";
    ClassicGameId[ClassicGameId["STS_POKER"] = 14] = "STS_POKER";
    ClassicGameId[ClassicGameId["RNG_WHEEL"] = 16] = "RNG_WHEEL";
    ClassicGameId[ClassicGameId["RNG_FOOTBALL_GRID"] = 17] = "RNG_FOOTBALL_GRID";
    ClassicGameId[ClassicGameId["BETWAY_LUCKY7"] = 21] = "BETWAY_LUCKY7";
    ClassicGameId[ClassicGameId["RNG_LUCKY7"] = 26] = "RNG_LUCKY7";
    ClassicGameId[ClassicGameId["SKYWARD"] = 27] = "SKYWARD";
    ClassicGameId[ClassicGameId["SKYWARD_GLS"] = 47] = "SKYWARD_GLS";
    ClassicGameId[ClassicGameId["RNG_ROULETTE"] = 28] = "RNG_ROULETTE";
    ClassicGameId[ClassicGameId["SHOVA52"] = 29] = "SHOVA52";
    ClassicGameId[ClassicGameId["ROULETTE_EURO_GE"] = 30] = "ROULETTE_EURO_GE";
    ClassicGameId[ClassicGameId["ROULETTE_EURO_LT"] = 31] = "ROULETTE_EURO_LT";
    ClassicGameId[ClassicGameId["ROULETTE_AMERICAN_GE"] = 32] = "ROULETTE_AMERICAN_GE";
    ClassicGameId[ClassicGameId["ROULETTE_FLASH_LT"] = 38] = "ROULETTE_FLASH_LT";
    ClassicGameId[ClassicGameId["RGS_ROULETTE_EURO"] = 68] = "RGS_ROULETTE_EURO";
    ClassicGameId[ClassicGameId["LUCKY_KICKS"] = 33] = "LUCKY_KICKS";
    // PLS Game Ids - T=Table
    ClassicGameId[ClassicGameId["PLS_BLACKJACK_T1"] = 34] = "PLS_BLACKJACK_T1";
    ClassicGameId[ClassicGameId["PLS_BLACKJACK_T2"] = 35] = "PLS_BLACKJACK_T2";
    ClassicGameId[ClassicGameId["PLS_BLACKJACK_T3"] = 36] = "PLS_BLACKJACK_T3";
    ClassicGameId[ClassicGameId["PLS_BLACKJACK_T4"] = 37] = "PLS_BLACKJACK_T4";
    ClassicGameId[ClassicGameId["PLS_BLACKJACK_T5"] = 43] = "PLS_BLACKJACK_T5";
    ClassicGameId[ClassicGameId["PLS_BLACKJACK_T6"] = 44] = "PLS_BLACKJACK_T6";
    ClassicGameId[ClassicGameId["PLS_BLACKJACK_T7"] = 45] = "PLS_BLACKJACK_T7";
    ClassicGameId[ClassicGameId["PLS_BLACKJACK_T8"] = 46] = "PLS_BLACKJACK_T8";
    ClassicGameId[ClassicGameId["PLS_BLACKJACK_T9"] = 63] = "PLS_BLACKJACK_T9";
    // ShowGames
    ClassicGameId[ClassicGameId["STARZLE"] = 22] = "STARZLE";
    ClassicGameId[ClassicGameId["GIZA"] = 23] = "GIZA";
    // Slot Games - Hinterzimmer Games
    ClassicGameId[ClassicGameId["CITRUS_SPLASH"] = 39] = "CITRUS_SPLASH";
    ClassicGameId[ClassicGameId["CANDY_COINS"] = 40] = "CANDY_COINS";
    ClassicGameId[ClassicGameId["LOTUS_WEALTH_WONDERS"] = 41] = "LOTUS_WEALTH_WONDERS";
    ClassicGameId[ClassicGameId["GIZA_SLOT"] = 42] = "GIZA_SLOT";
    ClassicGameId[ClassicGameId["GIZA_SLOT_RTP_94"] = 64] = "GIZA_SLOT_RTP_94";
    ClassicGameId[ClassicGameId["GIZA_SLOT_RTP_96"] = 65] = "GIZA_SLOT_RTP_96";
    ClassicGameId[ClassicGameId["BAD_BABOONS"] = 56] = "BAD_BABOONS";
    ClassicGameId[ClassicGameId["DRAGONS_FATE"] = 66] = "DRAGONS_FATE";
    ClassicGameId[ClassicGameId["LUCKY_LOKI"] = 67] = "LUCKY_LOKI";
    // Branded Slot Games
    ClassicGameId[ClassicGameId["CITRUS_SPLASH_HWB"] = 48] = "CITRUS_SPLASH_HWB";
    ClassicGameId[ClassicGameId["CITRUS_SPLASH_BETWAY"] = 49] = "CITRUS_SPLASH_BETWAY";
    ClassicGameId[ClassicGameId["CANDY_COINS_HWB"] = 50] = "CANDY_COINS_HWB";
    ClassicGameId[ClassicGameId["CANDY_COINS_BETWAY"] = 51] = "CANDY_COINS_BETWAY";
    ClassicGameId[ClassicGameId["LOTUS_WEALTH_WONDERS_HWB"] = 52] = "LOTUS_WEALTH_WONDERS_HWB";
    ClassicGameId[ClassicGameId["LOTUS_WEALTH_WONDERS_BETWAY"] = 53] = "LOTUS_WEALTH_WONDERS_BETWAY";
    ClassicGameId[ClassicGameId["GIZA_SLOT_BETWAY"] = 54] = "GIZA_SLOT_BETWAY";
    ClassicGameId[ClassicGameId["GIZA_SLOT_OLIMP"] = 55] = "GIZA_SLOT_OLIMP";
    ClassicGameId[ClassicGameId["BAD_BABOONS_BETWAY"] = 57] = "BAD_BABOONS_BETWAY";
    ClassicGameId[ClassicGameId["BAD_BABOONS_HWB"] = 58] = "BAD_BABOONS_HWB";
    // Tap Games
    ClassicGameId[ClassicGameId["PENGUIN_RUSH"] = 59] = "PENGUIN_RUSH";
    // Branded Tap Games
    ClassicGameId[ClassicGameId["PENGUIN_RUSH_HWB"] = 60] = "PENGUIN_RUSH_HWB";
    ClassicGameId[ClassicGameId["PENGUIN_RUSH_NEW_THEME"] = 61] = "PENGUIN_RUSH_NEW_THEME";
})(ClassicGameId || (ClassicGameId = {}));
